module.exports = __webpack_public_path__ + "7e4b29ba/img/send-icon.3cfb6275.svg";